const getToken = ({ token }) => token
const getHashToken = ({ hasToken }) => hasToken

export {
  getToken,
  getHashToken
}
